import { activeScenarioOperations } from '@ardoq/core';
import { getActiveScenarioState } from 'streams/activeScenario/activeScenario$';
import { selectedSlide$ } from 'streams/selectedSlide/selectedSlide$';
import { slides$ } from 'streams/slides/slides$';
import { toSlideOnScreen } from './toSlideOnScreen';
import { getFeatureContext } from 'streams/featureContext$';
import { loadedGraph$ } from 'traversals/loadedGraph$';
import { selectedModule$ } from 'appContainer/selectedModule$';
import {
  type FocusedChrome,
  focusedChromeOperations,
} from './focusedChromeOperations';

/**
 * Snapshot of {@link focusedChrome$} for imperative export-config builders,
 * which are plain functions called at menu-build time and have no stream to
 * thread the value through.
 */
export const focusedChromeNow = (): FocusedChrome =>
  focusedChromeOperations.toFocusedChrome({
    isInScenarioMode: activeScenarioOperations.isInScenarioMode(
      getActiveScenarioState()
    ),
    featureContext: getFeatureContext(),
    /* eslint-disable ardoq-lint/no-direct-stream-state-access -- this module is the snapshot seam; see the doc comment above */
    isViewpointMode: loadedGraph$.state.isViewpointMode,
    slideOnScreen: toSlideOnScreen(
      selectedSlide$.state,
      slides$.state,
      selectedModule$.state.selectedModule
    ),
    /* eslint-enable ardoq-lint/no-direct-stream-state-access */
  });

export const isReadOnlyVisualizationNow = (): boolean =>
  focusedChromeOperations.isReadOnlyVisualization(focusedChromeNow());
